import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Spinner, Alert } from 'react-bootstrap';
import { AiOutlineFileDone } from 'react-icons/ai';
import { FaArrowRight } from 'react-icons/fa6';
import "../../../assets/css/course.css";
import { Link, useNavigate } from "react-router-dom";
import FooterPage from '../../footer/FooterPage';

const API_BASE_URL = 'https://brainrock.in/brainrock/backend';

function Courses() {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 15 WORDS ONLY
  const getShortDescription = (text, words = 15) => {
    if (!text) return "";
    const splitText = text.split(" ");
    return splitText.length > words
      ? splitText.slice(0, words).join(" ") + "..."
      : text;
  };

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/course-items/`);
        if (!response.ok) throw new Error('Failed to fetch courses');

        const result = await response.json();
        const coursesData = result.data || result;

        const processedCourses = coursesData.map(course => {
          const formatCurrency = (value) =>
            new Intl.NumberFormat('en-IN', {
              style: 'currency',
              currency: 'INR'
            }).format(value);

          return {
            ...course,
            icon: course.icon ? `${API_BASE_URL}${course.icon}?t=${Date.now()}` : null,
            formattedPrice: formatCurrency(course.price),
            formattedOfferPrice: course.offer_price
              ? formatCurrency(course.offer_price)
              : null
          };
        });

        setCourses(processedCourses);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  return (
    <>
      <div className='Courses-banner'>
        <div className='site-breadcrumb-wpr'>
          <h2 className='breadcrumb-title'>Our Courses</h2>
          <ul className='breadcrumb-menu clearfix'>
            <li><Link className="breadcrumb-home" to="/">Home</Link></li>
            <li className='px-2'>/</li>
            <li><Link className="breadcrumb-about" to="/">Courses</Link></li>
          </ul>
        </div>
      </div>

      <Container className='ourteam-box mt-4 mb-3' style={{ overflow: 'hidden' }}>
        <div className="ourteam-section">
          {loading && (
            <div className="text-center my-5">
              <Spinner animation="border" />
            </div>
          )}

          {error && (
            <Alert variant="danger" className="my-5">{error}</Alert>
          )}

          {!loading && !error && (
            <Row className="g-4" style={{ margin: '0' }}>
              {courses.map((course) => (
                <Col
                  key={course.id}
                  lg={3}
                  md={4}
                  sm={6}
                  xs={12}
                  className="d-flex"  // Add this to make column flex container
                  style={{ padding: '10px' }}
                >
                  <div
                    className="service-box equal-card flex-fill d-flex flex-column"  // Added flex utilities
                    style={{
                      overflow: 'hidden'  // Removed height: auto as it's redundant
                    }}
                  >
                    <div className="service-icon text-center">
                      {course.icon ? (
                        <img
                          src={course.icon}
                          alt={course.title}
                          style={{ width: "60px", height: "60px" }}
                        />
                      ) : (
                        <AiOutlineFileDone size={50} />
                      )}
                    </div>

                    <div
                      className="service-desc course-sub-heading flex-fill d-flex flex-column"  // Added flex utilities
                    >
                      <h4 className="heading-5">{course.title}</h4>

                      <p className="flex-grow-1">  
                        {getShortDescription(course.description, 15)}
                      </p>

                      {course.category && (
                        <p className="course-info">
                          <span className="course-label">Category:</span>
                          <span className="course-value">{course.category}</span>
                        </p>
                      )}

                      {course.sub_category && (
                        <p className="course-info">
                          <span className="course-label">Sub Category:</span>
                          <span className="course-value">{course.sub_category}</span>
                        </p>
                      )}

                      {/* ===== AMAZON STYLE PRICE DISPLAY ===== */}
                      {course.formattedOfferPrice ? (
                        <>
                          <p className="course-info" style={{ marginBottom: '4px' }}>
                            Offer Price <span className="course-value">
                              {course.formattedOfferPrice}
                            </span>
                          </p>

                          <p className="course-info">
                            Price:&nbsp;
                            <span style={{ textDecoration: 'line-through' }}>
                              {course.formattedPrice}
                            </span>
                          </p>
                        </>
                      ) : (
                        <p className="course-info">
                          <span className="course-value" style={{ fontWeight: 'bold' }}>
                            {course.formattedPrice}
                          </span>
                        </p>
                      )}
                      {/* ===== END PRICE DISPLAY ===== */}

                      <p className="course-info">
                        <span className="course-label">Duration:</span>
                        <span className="course-value">{course.duration}</span>
                      </p>

                      <button
                        className="service-btn-read mt-auto"
                        onClick={() =>
                          navigate("/Training", {
                            state: { 
                              courseId: course.id,
                              courseData: {
                                id: course.id,
                                title: course.title,
                                description: course.description,
                                duration: course.duration,
                                price: course.price,
                                offer_price: course.offer_price,
                                formattedPrice: course.formattedPrice,
                                formattedOfferPrice: course.formattedOfferPrice,
                                category: course.category,
                                sub_category: course.sub_category
                              }
                            }
                          })
                        }
                      >
                        Read More <FaArrowRight />
                      </button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </div>
      </Container>

      <Container fluid className="br-footer-box">
        <FooterPage />
      </Container>
    </>
  );
}

export default Courses;
